<template>
  <div class="more-books">
    <hr />
    <h2 v-if="block.content.title" v-html="block.content.title" />
    <div class="books-grid">
      <a class="book-link" :href="'/' + book.uid" v-for="book in books" :key="book.uid">
        <div class="cover-wrap">
          <Image v-if="book.coverimages?.[0]?.url" :src="book.coverimages[0].url" :srcset="book.coverimages[0].srcset" sizes="20vw" :alt="book.title" />
          <div v-else class="cover-placeholder" />
        </div>
        <div class="book-info">
          <p class="book-title" v-html="book.title" />
          <p class="book-year" v-if="book.year">{{ book.year }}</p>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { useStore } from '../KQL.js'
  import { pageFromPath } from '../helpers.js'
  import Image from './Image.vue'

  const kql = useStore();
  const props = defineProps(['block', 'page']);

  const books = computed(() => {
    return (props.block.content.rows || [])
      .map(row => row.page?.[0])
      .filter(Boolean)
      .map(uid => pageFromPath(uid, kql.pages))
      .filter(Boolean);
  });
</script>

<style scoped>
@import '../css/breakpoints.css';

  .more-books {
    margin-top: 4rem;
  }

  hr {
    border: none;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    margin-bottom: 3rem;
  }

  h2 {
    font-family: "Copernicus", serif;
    font-size: 3rem;
    font-weight: normal;
    color: #f1f2f2;
    margin-bottom: 4rem;
    line-height: 1.2;
  }

  .books-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
    gap: 4rem 3rem;
  }

  @media (--phone) {
    .books-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 3rem 2rem;
    }
  }

  .book-link {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    text-decoration: none;
    color: #f1f2f2;
    transition: opacity 0.2s ease;
  }

  .book-link:hover {
    opacity: 0.75;
  }

  .cover-wrap {
    width: 100%;
    aspect-ratio: 346 / 556;
    overflow: hidden;
  }

  .cover-wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .cover-placeholder {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.1);
  }

  .book-info {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }

  .book-title {
    font-family: "Maison Neue Demi", sans-serif;
    font-size: 1.6rem;
    margin: 0;
    line-height: 1.3;
  }

  .book-year {
    font-family: "Copernicus", serif;
    font-size: 1.6rem;
    font-weight: normal;
    margin: 0;
    line-height: 1.4;
    opacity: 0.8;
  }
</style>
